import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { takeUntil } from 'rxjs/operators'
import { AuthService } from '../../services/auth.service'
import { DestroyService } from '../../services/destroy.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { ProducerService } from '../../services/producer.service'
import { ProducerType } from '../../types/producer.type'

@Component({
  selector: 'bmcore-beatmaker-info',
  templateUrl: './bmcore-beatmaker-info.component.html',
  styleUrls: ['./bmcore-beatmaker-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreBeatmakerInfoComponent implements OnChanges, OnInit {
  private readonly authService = inject(AuthService)
  private readonly destroy$ = inject(DestroyService)
  private readonly i18nService = inject(I18nService)
  private readonly producerService = inject(ProducerService)

  lg: LgType
  producer: ProducerType
  userId: number

  @Input() showVerificationIcon = false
  @Input() verificationIconSize = 24
  @Input() showFollowBtn = false

  @Input() beatmakerId: number

  @Output() closePlayerMobLgEvent = new EventEmitter()

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['beatmakerId']) {
      const changedBeatmakerId = changes['beatmakerId'].currentValue
      this.producerService
        .getInformation(changedBeatmakerId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          this.producer = res
        })
    }
  }

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.authService.user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.userId = user.id
    })
  }

  handleBeatmakerInfoClick() {
    this.closePlayerMobLgEvent.emit()
  }
}
